var React = require('react');

function BaselineStop24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M6 6h12v12H6z","key":1})]);
}

BaselineStop24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BaselineStop24px;

BaselineStop24px.default = BaselineStop24px;
